import React from 'react'
import {ModulePanel, ModuleHeader, ModuleBody, ModuleFooter} from 'containers/purchase/modules/module_panel'
import { useTranslation } from 'react-i18next'
import VehicleRateForm from './vehicle_rate_form'

const CarLocationModule = (props) => {
  const {config, machine, status} = props
  const [current, send] = machine
  const { t, i18n } = useTranslation()

  const setForm = (form) => {
    send({type: 'VEHICLE_RATE_FORM_CHANGE', form: form})
  }

  return (
    <ModulePanel>
      <ModuleHeader status={status} onClick={() => status === 'completed' ? send('REOPEN_VEHILCERATESTEP') : null}>
        <span>
          <i className="fa fa-users me-2" aria-hidden="true"/>
          {props.title}
        </span>
      </ModuleHeader>
      <ModuleBody status={status}>
        Prueba
      </ModuleBody>
      <ModuleFooter {...props}/>
    </ModulePanel>
  )
}

export default CarLocationModule